import Checkbox from 'Components/Base/Checkbox'
import Column from 'Components/Base/Column'
import Icon from 'Components/Base/Icon'
import Typography from 'Components/Base/Typography'
import { PrimaryPhysicianState } from 'hooks/usePatientIntake'
import React from 'react'
import styled from 'styled-components'

interface Props {
  phys
  primaryPhysician: PrimaryPhysicianState | undefined
  handleSetPrimaryPhysician: (phys: PrimaryPhysicianState) => void
  handleRemovePhys: (phys: PrimaryPhysicianState) => void
}
export default function PhysicianSelectCard({ phys, primaryPhysician, handleSetPrimaryPhysician, handleRemovePhys }: Props) {
  function physicianSelected() {
    if (primaryPhysician === phys) {
      handleSetPrimaryPhysician({
        hasPrimaryPhysician: false,
        firstName: '',
        lastName: '',
        city: '',
        state: '',
        quit: false,
      })
    } else {
      handleSetPrimaryPhysician(phys)
    }
  }

  return (
    <Card>
      <Checkbox styles={{ margin: '3px' }} onClick={physicianSelected} checked={primaryPhysician === phys ? true : false}></Checkbox>
      <Column styles={{ margin: '5px' }}>
        <Typography>{`Dr. ${phys.firstName} ${phys.lastName}`} | </Typography>
      </Column>
      <Column styles={{ margin: '5px' }}>
        <Typography>{`${phys.city}, ${phys.state}`}</Typography>
      </Column>
      {phys.patientAdded && (
        <div onClick={() => handleRemovePhys(phys)} style={{ marginLeft: 'auto' }}>
          <Icon name="trashX" styles={{ marginLeft: 'auto', marginTop: 5, cursor: 'pointer' }} color="#98A4AE" />
        </div>
      )}
    </Card>
  )
}

const Card = styled.div`
  padding: 5px 15px;
  margin-bottom: 5px;
  border: 1px solid #98a4ae;
  display: flex;
  max-width: 600px;
  border-radius: 5px;
`
